export interface CDR {
  date: string
  country: string
  bundle: string
  receiver: string
  data: string
  time: string
  min: number
}

export interface CdrBody {
  endDate: Date
  startDate: Date
  phoneNumber: string
}

export const isCDR = (cdr: any): cdr is Array<CDR> => {
  if (cdr === undefined) {
    return false
  }
  if (Array.isArray(cdr)) {
    return 'time' in cdr[0]
  }
  return 'time' in cdr
}

export const isCdrBody = (cdr: any): cdr is CdrBody => {
  if (cdr === undefined) {
    return false
  }
  return 'endDate' in cdr
}
